import { IS_APP } from "../../../vuplex/constants"

/**
 * Whether to offer the prompt: only in a browser that has the API (not the
 * native app, which has OneSignal) while the choice is still open. A decline
 * leaves permission no longer "default", which is the permanent off switch.
 */
export function shouldOfferNotificationBanner(): boolean {
  if (IS_APP) return false
  if (!("Notification" in window)) return false
  return Notification.permission === "default"
}
